import CategoryCard from "@/components/categoryCard/categoryCard";
import styles from "./helpCenter.module.scss";
import { helpCenterItems } from "@/lib/helpCenter";
import React, { useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useEffect, useRef } from "react";
import SearchBar from "@/components/searchBar/searchBar";
import { useRouter } from "next/router";
import CustomSpinner from "@/components/spinner/spinner";
import Masonry from "react-masonry-css";
import Head from "next/head";
import { useWordPressApi } from "@/hooks/useWordPressApi";

const helpCenter = () => {
  const router = useRouter();
  const { getHelpCenterCategories, currentLanguage } = useWordPressApi();
  const triggerRef = useRef(null);

  function isMobile() {
    const regex =
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }

  // gsap.registerPlugin(ScrollTrigger);

  // useEffect(() => {
  //   if (isMobile()) {
  //     gsap.from(triggerRef.current, {
  //       width: "95vw",
  //       borderRadius: "15px",

  //       scrollTrigger: {
  //         trigger: triggerRef.current,
  //         start: "top center",
  //         end: "+=1000",
  //         // markers: true,
  //         pin: false,
  //         scrub: true,
  //       },
  //     });
  //   } else {
  //     gsap.from(triggerRef.current, {
  //       width: "95vw",
  //       borderRadius: "15px",
  //       scrollTrigger: {
  //         trigger: triggerRef.current,
  //         start: "1000 center",
  //         end: "+=1000",
  //         markers: true,
  //         pin: false,
  //         scrub: true,
  //       },
  //     });
  //   }
  //   console.log(triggerRef.current);
  //   return () => {};
  // }, []);

  // useEffect(() => {
  // if (isMobile()) {
  //   gsap.to(triggerRef.current, {
  //     width: "1400px",
  //     borderRadius: "15px",

  //     scrollTrigger: {
  //       trigger: triggerRef.current,
  //       start: "400 center",
  //       end: "+=1000",
  //       // markers: true,
  //       pin: false,
  //       scrub: true,
  //     },
  //   });
  // } else {
  //   gsap.to("#nour", {
  //     width: "1400px",
  //     maxWidth: "100vw",
  //     borderRadius: "60px",

  //     scrollTrigger: {
  //       trigger: "#nour",
  //       start: "top center",
  //       end: "+=1000",
  //       markers: false,
  //       pin: false,
  //       scrub: true,
  //     },
  //   });
  //   // }
  //   console.log(triggerRef);
  //   return () => {};
  // }, []);
  const breakpointColumnsObj = {
    default: 2,
    1100: 1,
    700: 1,
    500: 1,
  };

  const [data, setData] = useState<any[] | null>(null);

  const [realId, setRealId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [allImages, setAllImages] = useState(null);
  const [categorydata, setCategoryData] = useState(null);
  const [currentUrl, setCurrentUrl] = useState("");
  const [domainUrl, setDomainUrl] = useState("");
  useEffect(() => {
    if (window.location.href) {
      setCurrentUrl(window.location.href);
      setDomainUrl(window.location.hostname);
    }
  }, []);

  useEffect(() => {
    (async () => {
      const data = (await getHelpCenterCategories()) as any[];

      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.slug != "uncategorized") {
          setCategoryData(element);
          setRealId(element.id);
        }
      }

      setData(data);
      setLoading(false);
    })();
  }, []);

  const baseUrl = `https://${domainUrl || "qrhub.io"}`;
  const defaultOgImage = `${baseUrl}/images/featured_images/qrhub-featured.jpg`;
  const defaultOgUrl = `${baseUrl}${router.asPath || ""}`;

  return (
    <>
      <Head>
        <title>QRHUB - Help Center</title>
        <meta name="description" content="Empower your business with tailored QR code Help Center" />
        <meta property="og:title" content="QRHUB - Help Center" />
        <meta property="og:description" content="Empower your business with tailored QR code Help Center" />
        <meta property="og:image" content={defaultOgImage} />
        <meta property="og:url" content={defaultOgUrl} />
      </Head>
      {loading ? (
        <>
          <CustomSpinner />
        </>
      ) : (
        <>
          <Head>
            <title>QRHUB - Help Center</title>
            <meta
              name="description"
              content="Empower your business with tailored QR code Help Center"
            ></meta>
            <meta property="og:title" content="QRHUB - Help Center"></meta>
            <meta
              property="og:description"
              content="Empower your business with tailored QR code Help Center"
            ></meta>
            <meta
              property="og:image"
              content={defaultOgImage}
            ></meta>
            <meta property="og:url" content={currentUrl}></meta>
          </Head>
          <div className={`${styles["heroContainer"]}`} ref={triggerRef}>
            <div className={`${styles["heroSection"]}`}>
              <h1>Help Center</h1>
              <div className={`${styles["searchContainer"]}`}>
                <SearchBar cats={data} isArticles={false} />
              </div>
            </div>
          </div>
          <div className={`${styles["helpCenter"]}`}>
            <div className={`${styles["helpCenterContainer"]} container`}>
              <div className="inner">
                <div className={`${styles["catergories"]}`}>
                  <Masonry
                    breakpointCols={breakpointColumnsObj}
                    // breakpointCols={2}
                    className={`${styles["my-masonry-grid"]}`}
                    columnClassName={`${styles["my-masonry-grid_column"]}`}
                  >
                    {data &&
                      data
                        .sort((a, b) => (a.id < b.id ? -1 : 1))
                        .map((item) => (
                          <React.Fragment key={item.id}>
                            {item.slug != "uncategorized" ? (
                              <>
                                <CategoryCard
                                  isArticles={false}
                                  title={item.name}
                                  description={item.description}
                                  categorySlug={item.slug}
                                  categoryId={item.id}
                                />
                              </>
                            ) : (
                              ""
                            )}
                          </React.Fragment>
                        ))}
                  </Masonry>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default helpCenter;
